import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { SilProjectDevice } from "server/models"
import { EDIT, WARNING } from "const"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_SIL_DEVICE,
    StoreType,
    addModal,
    moduleIds,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    Textarea,
    Button,
    Link,
    AlertMessage,
} from "client/components"

import SilUpdateDevice from "client/pages/sil/update/device"
import Copy from "client/pages/sil/device/copy"

const Form = () => {
    const baseRoute = useSelector((state: StoreType) => state.silDevice.baseDeviceRoute)
    const device = useSelector((state: StoreType) => state.silDevice.deviceView)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [showCopy, setShowCopy] = useState(false)

    const editUrl = `${baseRoute}/${EDIT}/${device.id}`

    const editAccess = !project.id
        ? hasAccess(PRM_SIL_DEVICE, EDIT)
        : hasProjectAccess(PRM_SIL_DEVICE, EDIT)

    const projectDevice = device as SilProjectDevice
    const isQidDevice = project.id && projectDevice.qidProductId !== null
    const isProjectDevice = project.id && projectDevice.qidProductId === null && projectDevice.deviceId === null

    const delimiter = "{0}"
    const qidDeviceUpdated = lang.qidDeviceUpdated.split(delimiter)
    const deviceUpdated = lang.deviceUpdated.split(delimiter)

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={device.logo || (isQidDevice ? Images.qidProductLogo : Images.silDeviceLogo)} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={device.name} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.manufacturer}</Label>
                                <Input type="text" value={device.manufacturer} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.description}</Label>
                                <Textarea value={device.description} readOnly />
                            </FormGroup>

                            {
                                projectDevice.qidMethod && (
                                    <FormGroup>
                                        <Label>{lang.method}</Label>
                                        <Input type="text" value={lang[projectDevice.qidMethod]} readOnly />
                                    </FormGroup>
                                )
                            }
                            {
                                projectDevice.qidModelId && (
                                    <FormGroup>
                                        <Label>{lang.model}</Label>
                                        <Input type="text" value={projectDevice.qidModelName} readOnly />
                                    </FormGroup>
                                )
                            }
                            {
                                projectDevice.qidSafetyFunctionId && (
                                    <FormGroup>
                                        <Label>{lang.safetyFunction}</Label>
                                        <Input type="text" value={projectDevice.qidSafetyFunctionName} readOnly />
                                    </FormGroup>
                                )
                            }
                            {
                                projectDevice.qidOptionId && (
                                    <FormGroup>
                                        <Label>{lang.option}</Label>
                                        <Input type="text" value={projectDevice.qidOptionName} readOnly />
                                    </FormGroup>
                                )
                            }
                            {
                                projectDevice.qidDatapointId && (
                                    <FormGroup>
                                        <Label>{lang.datapoint}</Label>
                                        <Input type="text" value={projectDevice.qidDatapointId} readOnly />
                                    </FormGroup>
                                )
                            }
                            {
                                (isProjectDevice || isQidDevice) && (
                                    <FormGroup>
                                        <Label>{lang.source}</Label>
                                        {
                                            isProjectDevice
                                            && <Input type="text" value={lang.projectDevice} readOnly />
                                        }
                                        {
                                            isQidDevice
                                            && <Input type="text" value={moduleList[moduleIds.qid].name} readOnly />
                                        }
                                    </FormGroup>
                                )
                            }
                            {
                                !isQidDevice && (
                                    <FormGroup>
                                        <Label>{lang.reference}</Label>
                                        <Input type="text" value={device.reference} readOnly />
                                    </FormGroup>
                                )
                            }

                            <FormGroup>
                                <Label>{lang.status}</Label>
                                <Input type="text" value={lang[device.status]} readOnly />
                            </FormGroup>

                            {
                                device.updated && (
                                    <AlertMessage variant={WARNING}>
                                        <b>{lang.warning}</b>
                                        <div>
                                            {isQidDevice ? qidDeviceUpdated[0] : deviceUpdated[0]}

                                            <Link
                                                href="/#"
                                                onClick={() => {
                                                    dispatch(addModal({
                                                        key: "updateDevice",
                                                        content: <SilUpdateDevice deviceId={device.id} />,
                                                    }))
                                                }}
                                            >
                                                {lang.here}
                                            </Link>

                                            {isQidDevice ? qidDeviceUpdated[1] : deviceUpdated[1]}
                                        </div>
                                    </AlertMessage>
                                )
                            }
                        </Col>
                        <Col xs={12}>
                            {
                                editAccess && (
                                    <Button
                                        row
                                        onClick={() => dispatch(addModal({ url: editUrl }))}
                                    >
                                        {lang.edit}
                                    </Button>
                                )
                            }
                            <Button row onClick={() => setShowCopy(true)}>{lang.copy}</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Copy
                device={device}
                show={showCopy}
                onClose={() => setShowCopy(false)}
            />
        </PageForm>
    )
}
export default Form
